const PaypalStub = {
  Button: {
    render: (): null => null
  }
};

export default PaypalStub;
